import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { InviteData } from '../../../stores/invites.store';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ts-invite-list',
  templateUrl: './invite-list.component.html',
  styleUrls: ['./invite-list.component.scss'],
  imports: [MatTableModule, MatButtonModule, TranslateModule, CommonModule, MatTooltipModule, ClipboardModule],
})
export class InviteListComponent implements OnChanges {
  @Input() invites: InviteData[] = [];
  @Input() loading = false;

  @Output() inviteRemoved = new EventEmitter<InviteData>();
  @Output() inviteQRClicked = new EventEmitter<InviteData>();
  @Output() inviteCopied = new EventEmitter<void>();

  // Store the container height when loading starts to prevent layout jumps
  public containerHeight: number | null = null;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    // When loading starts, capture the current height
    if (changes['loading'] && changes['loading'].currentValue === true) {
      const element = this.elementRef.nativeElement as HTMLElement;
      if (element && element.offsetHeight > 0) {
        this.containerHeight = element.offsetHeight;
      }
    }
    // When loading ends, clear the fixed height
    if (changes['loading'] && changes['loading'].currentValue === false) {
      this.containerHeight = null;
    }
  }

  public readonly showMobileLayout$: Observable<boolean> = new Observable<boolean>((observer) => {
    observer.next(false);
    observer.complete();
  });
}
